<!-- Verification limit reached page heading -->
<gds-heading
  [data]="{
    heading: limitReachedHeader,
  }"
  tagtype="h1"
  classes="heading-3"
>
</gds-heading>
<gds-spacer classes="spacer-70"></gds-spacer>

<!-- Verification limit reached supporting body copy -->
<gds-body
  class="B1-W2"
  [data]="{
    description: limitReachedBodyDescription,
  }"
  appLinkSpacebarActivation
>
</gds-body>
<gds-spacer classes="spacer-110"></gds-spacer>

<!-- Verification limit reached cancel button -->
<div class="action-bar">
  <gds-buttons
    [data]="{
      type: 'secondary',
      href: eventTargeturl,
      label:
        pageLabels?.['com.udx.account.onetimepasscode.button_cancel'] ||
        'Cancel',
      disabled: false,
      target: '',
    }"
    (buttonClicked)="onCancel()"
    (keydown)="onSpacebarPress($event)"
  >
  </gds-buttons>
</div>
<gds-spacer classes="spacer-120"></gds-spacer>
